import { render } from "./MobileAction.vue?vue&type=template&id=18a018af"
import script from "./MobileAction.vue?vue&type=script&lang=js"
export * from "./MobileAction.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__